// 리뷰 내재화
var loadReview = function(){
    // console.log("===============> LGE REVIEW !!!!");
    let modelId = (digitalData.productInfo)? digitalData.productInfo.model_id:null;
    let param = {
        b2cYN : lgkorUI.getHiddenInputData().b2cYN,
    };
    $.ajax({
        url: "/mkt/review/"+modelId+"/pdpReviewList",
        type: "GET",
        data: param,
        cache : false,
        contentType : 'application/x-www-form-urlencoded; charset=UTF-8;',
        success: function(data) {
            $('.KRP0012').find('.component-inner').html(data);
        },
        error: function(e) {
            console.log(e);
        }
    });
}

var getResultReviewForm = function(result){
    // loadReview();
    if(result && result.reload === "Y"){
        loadReview();
    }
};

(function() {
    // BTOCSITE-47831 소모품 PDP 페이지 내 최신제품 배너 삭제 요청
    // BTOCSITE-81509 [웹앱 접근성 개선활동] PDP - 일반, 케어용품/소모품, 가전구독, UP가전2.0
    let recommendationTemplate =
        '<div class="req-top-main-title" data-label="{{eventLabel}}">'+
            '<h4>혹시, 최신 제품에 관심 있으신가요?</h4>'+
        '</div>'+
        '<ul>'+
            '{{#each (item, idx) in recommendModels}}'+
                '<li>'+
                    '<a href="{{item.modelUrlPath}}" data-contents="{{item.sku}}/{{item.modelName}}/{{scenarioNo}}/{{idx + 1}}/{{recommendLen}}">'+
                        '<span class="req-img-area">'+
                            '<img src="{{item.imageAddr}}" alt="">'+
                        '</span>'+
                        '<span class="req-text-area">'+
                            '<span class="req-title-inner">'+
                                '<span class="req-main-title">{{#raw item.modelDisplayName}}</span>'+
                                '<span class="req-sub-title">{{item.modelName}}</span>'+
                            '</span>'+
                            '<span class="req-product-info">'+
                                '<em class="product-price">{{item.obsSellingPrice.toString().replace(/\\B(?=(\\d{3})+(?!\\d))/g, \',\')}}</em>'+
                                '<em class="product-unit">원</em>'+
                            '</span>'+
                        '</span>'+
                    '</a>'+
                '</li>'+
            '{{/each}}'+
        '</ul>'
    ;
    // BTOCSITE-81509 [웹앱 접근성 개선활동] PDP - 일반, 케어용품/소모품, 가전구독, UP가전2.0
    var KRP0012 = {
        init: function() {
            loadReview();
            var self = this;

            // 키오스크 여부
            var kiosk = lgkorUI.getParameterByName("kiosk");
            self.kiosk = lgkorUI.stringToBool(kiosk);
            if (!self.kiosk) self.disposablePersonalRecommendation();

        },
        // S : BTOCSITE-8083
        reviewWrite: function() {
            var $section = $('.KRP0012');
            var productcode = $section.data('productCode');
            var ajaxUrl = '/mkt/api/product/retrieveProductRegisterInfo';
            if(location.pathname == '/html/components/KRP0012.html') ajaxUrl = '/lg5-common/data-ajax/pdp/pdp_status.json';
            var options = {
                isMobile: vcui.detect.isMobile,
                loginFlag : digitalData.hasOwnProperty("userInfo") && digitalData.userInfo.unifyId ? true : false,
                productcode : $section.data('productCode'),
                isProduct: true,
                isEventTime: false,
                ownStatus: false,
                orderStatus: false,
                cremaReviewTemplate: '<div class="review-write-wrap">'+
                /*s:BTOCSITE-39526-AI리뷰픽*/
                /*
                '{{#if isProduct}}' +
                    '<div class="txt-area">'+
                '{{#if isEventTime}}' +
                    '<p>제품 리뷰 작성하면 최대 <strong>3,000P</strong>의 멤버십 포인트를 드립니다.</p>'+ //BTOCSITE-28137
                '{{#else}}' +
                    '<p>보유 제품 등록하고 제품 리뷰 작성하면 최대 <strong>3,000P</strong>의 멤버십 포인트를 드립니다.</p>{{/if}}'+
                    '</div>' +
                '{{/if}}'+
                */
                 /*e:BTOCSITE-39526-AI리뷰픽*/
                '<button type="button" class="{{#if orderStatus || isEventTime}}crema-new-review-link{{/if}} btn" data-product-code="{{productcode}}" data-own-status="{{ownStatus}}" {{#if isMobile}}data-review-source="mobile_my_orders"{{/if}}>상품 리뷰 작성하기</button>'+
                '</div>'
            };
            var sendata = {
                modelName: options.productcode,
                modelId: (digitalData.productInfo)? digitalData.productInfo.model_id:null,
                unifyId: (digitalData.userInfo)? digitalData.userInfo.unifyId:null,
            };
            var chkIE = false;
            var mutationObserver = new MutationObserver(function(entries) {
                entries.forEach(function(entry){
                    var id = crema.popup !== undefined ? crema.popup.iframe_id:'crema-review-popup';
                    if(vcui.detect.isIE) {
                        if($(entry.target).is('#'+id)) {
                            chkIE = true;
                        }
                        if(chkIE && !$('#'+id).is(':visible')) {
                            chkIE = false;
                            // console.log(crema.iframe_manager.iframes)
                            $('.KRP0012-crema-review').find('iframe').attr('src', $('.KRP0012-crema-review').find('iframe').attr('src'))
                        }
                    }else {
                        if(entry.removedNodes.length > 0) {
                            $(entry.removedNodes).each(function() {
                                if($(this).is('#'+id)) {
                                    // console.log('remove', crema)
                                    crema.message_handler.reload_all(crema.iframe_manager.iframes);
                                }
                            })
                        }
                    }
				});
            });
            lgkorUI.requestAjaxData(ajaxUrl, sendata, function(result) {
                var data = result.data[0];

                //var appendTarget = $section.find('.review-info-text').size()>0 ? $section.find('.review-info-text'): $section.find('.review-wrap');
                var appendTarget = $section.find('.accordion-custom-outter').size()>0 ? $section.find('.accordion-custom-outter'): $section.find('.review-wrap');
                /* BTOCSITE-53461 START */
                if($section.find('.message-box-new').size()>0){
                    appendTarget = $section.find('.message-box-new');
                }
                /* BTOCSITE-53461 END */
                /* BTOCSITE-63050 START */
                if($section.find('.review-banner-area.pc-only').size()>0){
                    appendTarget = $section.find('.review-banner-area.pc-only');
                }
                /* BTOCSITE-63050 END */
                options.orderStatus = (options.loginFlag && lgkorUI.stringToBool(data.isregistered)) ? true:false;
                options.ownStatus = lgkorUI.stringToBool(data.isregistered);
                options.isProduct = lgkorUI.stringToBool(data.isproduct);
                options.isEventTime = lgkorUI.stringToBool(data.iseventtime);//BTOCSITE-28137

                /*s:BTOCSITE-39526-AI리뷰픽*/
                if(options.isProduct){
                    if(options.isEventTime){
                        $("#aiReviewMsg").html('제품 리뷰 작성하면 최대 <strong>3,000P</strong>의 멤버십 포인트를 드립니다.');
                    }else{
                        $("#aiReviewMsg").html('보유 제품 등록하고 제품 리뷰 작성하면 최대 <strong>3,000P</strong>의 멤버십 포인트를 드립니다.');
                    }
                }else{
                    $("#aiReviewMsg").remove();
                }
                /*e:BTOCSITE-39526-AI리뷰픽*/

                $section.find('.review-write-wrap').remove();	// 상품 리뷰 작성하기 삭제, 중복생성 방지
                appendTarget.before(vcui.template(options.cremaReviewTemplate, options));

                /*s:BTOCSITE-39526-AI리뷰픽*/
                // if($('.review-info-text').hasClass('custom1')) {
                //     return;
                // } else {
                //     appendTarget.before(vcui.template(options.cremaReviewTemplate, options));
                // }
                /*e:BTOCSITE-39526-AI리뷰픽*/

                lgkorUI.cremaReload();

                mutationObserver.observe($('body')[0], { attributes: true, childList: true, subtree: true });
            },"POST", null, null, null, null, function(request){
                var err = (request == undefined) ? 'undefined' : request.status;
                console.log("ERROR : " + err);
                // $section.find('.review-info-text').before(vcui.template(options.cremaReviewTemplate, options));
            });
            var flag = false;
            $section.off("click").on('click','.review-write-wrap .btn', function(e) {
                if(!flag) {
                    flag = true;
                    var msg = options.loginFlag ? '보유제품 등록 후 리뷰 등록 가능합니다':'리뷰 작성을 위해 로그인을 해주세요.';
                    var opt  = {
                        typeClass: options.loginFlag ? 'crema-review-confirm':'',
                        okBtnName: options.loginFlag ? '보유제품 등록하기':'예',
                        cancel: function(){
                            flag = false;
                        },
                        ok: function(){
                        	var link =  options.loginFlag ? '/my-page/manage-products?modelCode='+productcode: '/sso/member/login';
                            location.href = link;
                        }
                    };

                    if(options.isEventTime) { //BTOCSITE-28137
                    	if(!options.loginFlag) {
                    		lgkorUI.confirm(msg, opt);
                    	}
                    } else {
                    	if(!lgkorUI.stringToBool($(this).attr('data-own-status'))) {
                    		lgkorUI.confirm(msg, opt);
                    	}
                    }
                }
                return false;
            });
        },
        // E : BTOCSITE-8083
        fnAiReview : function (){
            var aiParam = {
                modelId: (digitalData.productInfo)? digitalData.productInfo.model_id:null,
            };

            lgkorUI.requestAjaxData('/mkt/api/product/retrieveAiReviewInfo',aiParam ,function(result) {
                //console.log('result Data : ___________________________', result.data[0]);
                var aiReviewList = result.data[0].aiReviewList;
                var aiReviewCount = result.data[0].aiReviewCount;
                var totalCnt = 0;

                if(aiReviewList !=null && aiReviewList.length > 0){
                    totalCnt = result.data[0].aiReviewList[0].totalCount;
                }

                var _html = "";

                if (aiReviewCount != null && aiReviewCount > 1) {
                    _html += '<div class="review-ai-content-inner" >';
                    _html += '  <div class="review-ai-content-title">';
                    // [BTOCSITE-51737] AI 리뷰픽 문구 변경 START
                    _html += '      <strong>여러 사이트에 흩어져 있는 리뷰를<br> <em>한눈에 볼 수 있게</em> 요약해 봤어요.</strong>';
                    _html += '      <span>AI가 PICK한 ' + totalCnt + '명의 리뷰입니다.</span>';
                    // [BTOCSITE-51737] AI 리뷰픽 문구 변경 END
                    _html += '  </div>';
                    _html += '  <div class="review-ai-content-subtitle">';
                    _html += '      <ul>';
                    for (var i = 0; i < aiReviewList.length; i++) { // loop start
                        _html += '        <li>';
                        _html += `            <span>${aiReviewList[i].attributeName}</span>`;
                        _html += `            <em>${aiReviewList[i].sentence}</em>`;
                        _html += '        </li>';
                    }
                    _html += '      </ul>';
                    _html += '  </div>';
                    _html += '</div>';

                    $("#reviewAiContentArea").append(_html);

                }

                },"POST" ,"json");
        },
        // BTOCSITE-39526 ai리뷰
        aiReviewAcc: function() {
            /* BTOCSITE-39526 AI리뷰픽 확대 1차 - 커스텀 아코디언1 - 20230714 start */
            setTimeout(function() {
                var targ = $('.review-info-text.custom1');
                var bt1 = $('.titleBt').outerHeight(true);
                function accoClose() {
                    var cont1 = $('.accordion-custom-outter .bullet-list .b-txt:first-child').outerHeight(true);
                    var padding = parseInt($('.review-info-text').css('padding-top')) + parseInt($('.review-info-text').css('padding-bottom'));
                    var math1 = bt1 + cont1 + padding;
                    targ.css('height', math1);
                }
                function accoOpen() {
                    var math1;
                    var cont1 = $('.accordion-custom-outter .bullet-list').outerHeight(true);
                    var padding = parseInt($('.review-info-text').css('padding-top')) + parseInt($('.review-info-text').css('padding-bottom'));
                    var mobH = targ.find('.titleBt').outerHeight() + targ.find('.bullet-list').outerHeight();
                    if($(window).width() < 769) {
                        math1 = mobH + padding;
                    } else {
                        math1 = bt1 + cont1 + padding;
                    }
                    targ.css('height', math1);
                }
                accoClose();
                aiReviewAccodion();
                $(window).resize(function() {
                    aiReviewAccodion();
                    if(targ.hasClass('active')) {
                        accoOpen();
                    } else {
                        accoClose();
                    }
                });

                function aiReviewAccodion() {
                    $('.titleBt').on('click', function(){
                        if(targ.hasClass('active')){
                            targ.removeClass('active');
                            accoClose();
                        } else {
                            targ.addClass('active');
                            accoOpen();
                        }
                    });
                }
            }, 500);
            /* BTOCSITE-39526 AI리뷰픽 확대 1차 - 커스텀 아코디언1 end */
        },
        /* BTOCSITE-46610 [퍼블리싱] AI 리뷰픽 영역 문구 추가 start */
        aiReviewTooltipToggle: function() {
            setTimeout(function() {
                function pdpTooltipToggle() {
                    $(document).on('click', '.tooltip-pdp', function(){
                        var target1 = $(this).next(".tooltip-box-outter");
                        if (target1.hasClass('active')){
                            target1.removeClass("active");
                            console.log("tooltip-toggle-off");
                        }
                        else {
                            target1.addClass("active");
                            console.log("tooltip-toggle-on");
                        }
                    });
                }
                pdpTooltipToggle();
                console.log("ev1");
            }, 500)
        },
        aiReviewTooltipOff1: function() {
            setTimeout(function() {
                function pdpTooltipOff1() {
                    $(document).on('click', '.tooltip-box-outter .btn-close', function(){
                        var target2 = $(this).parent(".tooltip-box-outter");
                        if (target2.hasClass('active')){
                            target2.removeClass("active");
                            console.log("tooltip-off1");
                        }
                    });
                }
                pdpTooltipOff1();
                console.log("ev2");
            }, 500)
        },
        aiReviewTooltipOff2: function() {
            setTimeout(function() {
                function pdpTooltipOff2() {
                    $(document).on('mouseup', function (e){
                        if ($(".tooltip-box-outter").hasClass('active')){
                            if($(".tooltip-box-outter").has(e.target).length==0) {
                                $(".tooltip-box-outter").removeClass('active');
                                console.log("tooltip-off2");
                            }
                        }
                    });
                }
                pdpTooltipOff2();
                console.log("ev3");
            }, 500)
        },
        /* BTOCSITE-46610 [퍼블리싱] AI 리뷰픽 영역 문구 추가 end */

        /* BTOCSITE-47831 소모품 PDP 페이지 내 최신제품 배너 삭제 요청 */
        disposablePersonalRecommendation: function () {
            try {
                let productInfo = (digitalData.productInfo) ? digitalData.productInfo : null;
                let isLogin = digitalData.hasOwnProperty("userInfo") && digitalData.userInfo.unifyId ? true : false;
                let isDisposable = (productInfo && productInfo.model_gubun === "소모품") ? true : false;

                if (!isLogin && isDisposable) {
                    window.addEventListener('scroll', KRP0012.onViewport);

                    let modelSku = productInfo.model_sku !== null ? productInfo.model_sku : "";
                    if (modelSku !== "" && modelSku.length > 0 && modelSku.charAt(modelSku.length - 1) === ".") {
                        modelSku = modelSku.slice(0, -1);
                    }

                    let param = {
                        unifyId: lgkorUI.stringToBool(loginFlag) ? digitalData.hasOwnProperty("userInfo") && digitalData.userInfo.unifyId : "",
                        modelId: productInfo.model_id !== null ? productInfo.model_id : "",
                        sku: modelSku,
                        smartHomeFlag: "N",
                        clientId: lgkorUI.getCookie('_ga')
                    };
                    let personalRecommendation = "";

                    lgkorUI.requestKongAjax("itemsvc", "/ajax/v1/product/retrievePersonalRecommendation", {
                        method: "POST",
                        data: param,
                        success: function (result) {
                            personalRecommendation = result.data;

                            let $recommend = $('div.item-recommend-wrap.recommend-type-b');

                            if (personalRecommendation.recommendModels !== null && personalRecommendation.recommendModels.length > 0) {
                                let wrapDisplayFlag = false;
                                if (["s2_5", "s2_5_1", "s2_5_2"].includes(personalRecommendation.scenarioNo)) wrapDisplayFlag = true;

                                if (wrapDisplayFlag) {
                                    personalRecommendation.recommendLen = personalRecommendation.recommendModels.length;

                                    let recommendModelList = '';
                                    for (var i = 0; i < personalRecommendation.recommendLen; ++i) {
                                        recommendModelList += personalRecommendation.recommendModels[i].sku + '/';
                                    }
                                    personalRecommendation.eventLabel = personalRecommendation.scenarioNo + '/' + recommendModelList.slice(0, -1);

                                    $recommend.css('display', 'block');
                                    $recommend.append(vcui.template(recommendationTemplate, personalRecommendation));

                                    if ((window.innerWidth > 767 && personalRecommendation.recommendLen > 5)
                                        || (window.innerWidth <= 767 && personalRecommendation.recommendLen > 2)) {
                                        $recommend.find('ul').on('scroll', function () {
                                            let recommendEventCategory = "클릭";
                                            let recommendEventAction = "PDP 개인화 추천 영역 - 스크롤 클릭";
                                            let recommendEventLabel = "클릭 컨텐츠 : 스크롤 이동";
                                            KRP0012.pushDataLayer('', recommendEventCategory, recommendEventAction, recommendEventLabel);
                                            $recommend.find('ul').off('scroll');
                                        });
                                    }
                                } else { // 미노출
                                    handleNoneDisplay(personalRecommendation.scenarioNo);
                                }
                            } else if (personalRecommendation.scenarioNo !== null) { // 미노출
                                handleNoneDisplay(personalRecommendation.scenarioNo);
                            }
                        },
                        error: function (e) {
                            console.log(e);
                        }
                    });
                }

                function handleNoneDisplay(scenarioNo) {
                    let recommendEventCategory = "배너노출";
                    let recommendEventAction = "PDP 배너 노출 - 개인화 추천";
                    let recommendEventLabel = scenarioNo.replace("s", "e");
                    KRP0012.pushDataLayer('', recommendEventCategory, recommendEventAction, recommendEventLabel);
                }
            } catch (e) {
                console.log(e);
            }
        },

        /* target 영역이 화면에 완전히 노출되는 경우 true */
        isElementInViewport: function(target) {
            try {
                let viewportHeight  = $(window).height();
                let scrollTop  = $(window).scrollTop();
                let targetTop = target.offset().top;
                let targetHeight = target.height();

                return ((targetTop + targetHeight) < (viewportHeight + scrollTop)) && (targetTop > scrollTop);
            } catch (e) {
                console.log(e);
            }
        },

        onViewport: function() {
            try {
                let $recommendWrap = $('div.item-recommend-wrap.recommend-type-b');
                let recommendEventLabel = $recommendWrap.find('div.req-top-main-title').attr('data-label');

                if (KRP0012.isElementInViewport($recommendWrap) && recommendEventLabel !== null) {
                    let recommendEventCategory = "배너노출";
                    let recommendEventAction = "PDP 배너 노출 - 개인화 추천";
                    KRP0012.pushDataLayer('', recommendEventCategory, recommendEventAction, recommendEventLabel);
                    window.removeEventListener('scroll', KRP0012.onViewport);
                }
                if (recommendEventLabel === null || $recommendWrap.css('display') === "none") { // 영역이 존재하지 않는 경우
                    window.removeEventListener('scroll', KRP0012.onViewport);
                }
            } catch (e) {
                console.log(e);
            }
        },

        /* GA 태그 호출 */
        pushDataLayer: function(eventName, eventCategory, eventAction, eventLabel) {
            if(dataLayer) {
                dataLayer.push({
                    'event': 'customEvent',
                    'ga4event': eventName,
                    'customEventCategory': eventCategory,
                    'customEventAction': eventAction,
                    'customEventLabel': eventLabel
                });
            }
        }

    }

    // BTOCSITE-26022, PDP 컴포넌트 초기화 함수 추가, type: PROD or CONTENTS
    function SAVE_COMPONENT_PDP_DOM_MNG() {
        if (typeof __PDP_DOM_MNG__ === 'undefined') return;
        __PDP_DOM_MNG__.add({
            type: 'REVIEW', name: 'KRP0012', isFirstLoad: false, fn: function () {
                if(!document.querySelector('.KRP0012')) return false;
                //$('.KRP0012').buildCommonUI();
                KRP0012.init();
            }
        });
    }

    SAVE_COMPONENT_PDP_DOM_MNG();

    $(document).ready(function(){
        SAVE_COMPONENT_PDP_DOM_MNG();

        if(!document.querySelector('.KRP0012')) return false;
        //$('.KRP0012').buildCommonUI();
        KRP0012.init();
    });
})();